import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow-md p-8 mb-8">
        <div className="flex items-start gap-6">
          <img
            src="head.jpg"
            alt="The Lizard Coat Photo Flyer"
            className="w-32 h-32 rounded-lg object-cover"
          />
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Thanks for visiting!</h2>
            <p className="text-gray-600 italic mb-3">This site was last updated 02/18/2026.</p>
            <div className="flex gap-4">
              <a
                href="https://github.com/jchilton"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors"
                aria-label="GitHub"
              >
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@jchilton"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-red-600 transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-8">
        <section className="mb-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Phase 3:</h3>
          <ol className="list-decimal list-inside space-y-4 ml-4">
            <li className="text-gray-700">
              <span className="font-medium">Feb. 2023: Basic Microcontroller Demo</span>
              <a
                href="https://www.youtube.com/v/ZSObrK_j550"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 ml-2"
              >
                (view on YouTube)
              </a>
              <div className="mt-2">
                {/*
                <iframe
                  width="336"
                  height="189"
                  src="https://www.youtube.com/embed/ZSObrK_j550"
                  title="YouTube video player"
                  className="border-0 rounded"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  allowFullScreen
                />
                */}
              </div>
            </li>
            <li className="text-gray-700">
              <span className="font-medium">Aug. 2022:</span>{' '}
              <a href="/coffee-pot" className="text-blue-600 hover:text-blue-800">
                Wireless Coffee Pot
              </a>
            </li>
            <li className="text-gray-700">
              <span className="font-medium">2026:</span>{' '}
              <a href="/my-keeb" className="text-blue-600 hover:text-blue-800">
                My Keyboard
              </a>
            </li>
          </ol>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Phase 2:</h3>
          <ol className="list-decimal list-inside space-y-4 ml-4">
            <li className="text-gray-700">
              <span className="font-medium">Nov. 2021: Spiderweb generator</span>
              <ul className="list-disc list-inside ml-6 mt-2 space-y-2">
                <li>
                  <a href="/swgen" className="text-blue-600 hover:text-blue-800">
                    SWGen—Spiderweb Generator browser-based software
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtu.be/CcmJMs4q_v8"
                    className="text-blue-600 hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Video part 1
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtu.be/VOBWayA7-1w"
                    className="text-blue-600 hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Video part 2
                  </a>
                </li>
              </ul>
            </li>
            <li className="text-gray-700">
              <span className="font-medium">Nov. 2021:</span>{' '}
              <a href="/frc-360-logo" className="text-blue-600 hover:text-blue-800">
                Old FRC Team 360 Logo
              </a>
            </li>
          </ol>
        </section>

        <section>
          <h3 className="text-xl font-bold text-gray-900 mb-4">Phase 1:</h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li className="text-gray-700">
              <a href="/publications" className="text-blue-600 hover:text-blue-800">
                My articles, essays, publications, etc.
              </a>
            </li>
            <li className="text-gray-700">
              <a href="/reading-journal" className="text-blue-600 hover:text-blue-800">
                My reading journal
              </a>
            </li>
            <li className="text-gray-700">
              <span className="font-medium">June, 2021:</span>{' '}
              <a href="lzc.pdf" className="text-blue-600 hover:text-blue-800">
                The lizard jacket
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  )
}
